import { Card, Form, Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { userLogin } from "./api/user.js";
import axios from "axios";

export default function Login() {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      console.log("start login", values);
      const res = await userLogin(values);
      const { token, user } = res.data;
      console.log("login res", res.data);
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      message.success("登录成功");
      navigate("/");
    } catch (err) {
      message.error(err.response?.data?.message || "登录失败");
    }
  };

  return (
    <div style={wrapperStyle}>
      <Card title="用户登录" style={{ width: 360 }}>
        <Form onFinish={onFinish} layout="vertical">
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: "请输入用户名" }]}
          >
            <Input prefix={<UserOutlined />} />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            登录
          </Button>

          <div style={{ marginTop: 12, textAlign: "center" }}>
            没有账号？ <Link to="/register">去注册</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
}

const wrapperStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f5f5f5",
};
